const closeReasonTypeOptions = {
  HFB: "HFB",
  AMOUNT: "AMOUNT",
  OTHER: "OTHER",
  NEW_TESTBUY_CREATED: "NEW TEST BUY CREATED",
};

export default closeReasonTypeOptions;
